/* =====================================================================
   MENSORA PETS: landing de un solo producto dentro de TIENDAZO VIRAL.
   Igual que la vista previa, pero el carrito es el REAL de Shopify
   (/cart/add.js, /cart/change.js, /cart.js) y el pago va a /checkout.
   ===================================================================== */
(function(){
  var root = document.querySelector('.mensora-pets');
  if (!root) return;

  var CFG = {};
  try { CFG = JSON.parse(document.getElementById('mp-config').textContent); } catch (e) {}
  var VARIANT = CFG.id;
  var GLOVE = CFG.gloveId || null;   // guante de regalo ($0): va en la orden para que DSers lo pida solo
  var PRICE = (CFG.price || 0) / 100;
  var WAS = (CFG.was || 0) / 100;
  var MAX = 99;

  var $ = function(s, c){ return (c || document).querySelector(s); };
  var $$ = function(s, c){ return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var money = function(n){ return '$' + n.toFixed(2); };
  var pad = function(n){ return (n < 10 ? '0' : '') + n; };
  var live = $('#mp-live');
  var say = function(t){ live.textContent = ''; setTimeout(function(){ live.textContent = t; }, 30); };

  var inCart = 0;    // cuántos extensores hay en el carrito
  var lineKey = null; // clave de esa línea en el carrito de Shopify

  $('#mp-year').textContent = new Date().getFullYear();

  // ---------- barra de oferta: los mensajes suben ----------
  var msgs = $$('.mp-sale-msg');
  var still = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (msgs.length > 1 && !still){
    var mi = 0;
    setInterval(function(){
      var cur = msgs[mi], nxt = msgs[(mi + 1) % msgs.length];
      nxt.classList.remove('is-out');
      cur.classList.remove('is-on'); cur.classList.add('is-out');
      nxt.classList.add('is-on');
      setTimeout(function(){ cur.classList.remove('is-out'); }, 650);
      mi = (mi + 1) % msgs.length;
    }, 3200);
  }

  // ---------- galería ----------
  var gallery = $('#mp-gallery');
  var slides = $$('.mp-slide', gallery);
  var thumbs = $$('.mp-thumb', root);
  var current = 0;
  var show = function(n){
    current = (n + slides.length) % slides.length;
    slides.forEach(function(s, i){ s.hidden = i !== current; });
    thumbs.forEach(function(t, i){ t.setAttribute('aria-current', i === current ? 'true' : 'false'); });
    $('#mp-cap-text').textContent = slides[current].getAttribute('data-cap');
    $('#mp-cap-num').textContent = pad(current + 1) + ' / ' + pad(slides.length);
  };
  $$('[data-mp-go]', gallery).forEach(function(b){
    b.addEventListener('click', function(){ show(current + (+b.getAttribute('data-mp-go'))); });
  });
  thumbs.forEach(function(t){
    t.addEventListener('click', function(){ show(+t.getAttribute('data-mp-slide')); });
  });
  gallery.addEventListener('keydown', function(e){
    if (e.key === 'ArrowLeft'){ show(current - 1); e.preventDefault(); }
    if (e.key === 'ArrowRight'){ show(current + 1); e.preventDefault(); }
  });

  // ---------- cantidad ----------
  var qty = $('#mp-qty');
  var readQty = function(){ var v = parseInt(qty.value, 10); return isNaN(v) ? 1 : Math.min(MAX, Math.max(1, v)); };
  var paintQty = function(){
    var v = readQty(); qty.value = v;
    $$('[data-mp-step]', root).forEach(function(b){
      var step = +b.getAttribute('data-mp-step');
      b.disabled = (step < 0 && v <= 1) || (step > 0 && v >= MAX);
    });
  };
  $$('[data-mp-step]', root).forEach(function(b){
    b.addEventListener('click', function(){ qty.value = readQty() + (+b.getAttribute('data-mp-step')); paintQty(); });
  });
  qty.addEventListener('change', paintQty);
  qty.addEventListener('blur', paintQty);

  // ---------- ventanas ----------
  var opener = null;
  var open = function(dlg, trigger){
    opener = trigger || document.activeElement;
    if (typeof dlg.showModal === 'function') dlg.showModal(); else dlg.setAttribute('open', '');
  };
  $$('.mp-dialog').forEach(function(dlg){
    dlg.addEventListener('close', function(){ if (opener && opener.focus) opener.focus(); });
    dlg.addEventListener('click', function(e){ if (e.target === dlg) dlg.close(); });
    $$('[data-mp-close]', dlg).forEach(function(b){ b.addEventListener('click', function(){ dlg.close(); }); });
  });

  var zoom = $('#mp-zoom');
  $('#mp-open-zoom').addEventListener('click', function(e){
    var img = $('img', slides[current]);
    var big = $('#mp-zoom-img');
    big.src = img.currentSrc || img.src;
    big.alt = img.alt;
    open(zoom, e.currentTarget);
  });

  // ---------- carrito real de Shopify ----------
  var cart = $('#mp-cart'), body = $('#mp-cart-body'), foot = $('#mp-cart-foot');

  var postJSON = function(url, datos){
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(datos)
    }).then(function(r){
      if (!r.ok) throw new Error('cart ' + r.status);
      return r.json();
    });
  };

  var gloveQty = 0;

  var tomarEstado = function(c){
    inCart = 0; lineKey = null; gloveQty = 0;
    (c && c.items || []).forEach(function(it){
      if (it.variant_id === VARIANT){ inCart = it.quantity; lineKey = it.key; }
      if (GLOVE && it.variant_id === GLOVE){ gloveQty += it.quantity; }
    });
    paintCart();
    return c;
  };

  // pone el extensor y el guante en la misma cantidad, en una sola llamada
  var fijarCantidades = function(n){
    var updates = {};
    updates[VARIANT] = n;
    if (GLOVE) updates[GLOVE] = n;
    return postJSON('/cart/update.js', { updates: updates }).then(tomarEstado);
  };

  var leerCarrito = function(){
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function(r){ return r.json(); })
      .then(tomarEstado)
      .then(function(c){
        // si el guante no coincide con los extensores (p. ej. lo quitaron en /cart), se corrige
        if (GLOVE && gloveQty !== inCart) return fijarCantidades(inCart);
        return c;
      });
  };

  var cambiar = function(n){
    return fijarCantidades(Math.min(MAX, Math.max(0, n)))
      .catch(function(){ say('Something went wrong. Please try again.'); });
  };

  var paintCart = function(){
    var count = $('#mp-cart-count');
    count.textContent = inCart;
    count.setAttribute('aria-label', inCart + (inCart === 1 ? ' item' : ' items'));
    $('#mp-cart-title-n').textContent = inCart ? '(' + inCart + ')' : '';

    if (!inCart){
      foot.hidden = true;
      body.innerHTML =
        '<div class="mp-empty">' +
          '<h3 class="mp-h3">Nothing in here yet.</h3>' +
          '<p>Launch deal: ' + money(WAS - PRICE) + ' off the extender and a free hair remover glove.</p>' +
          '<a class="mp-btn mp-btn--cta" href="#product" data-mp-goto>See the extender <svg class="mp-icon"><use href="#i-arrow"/></svg></a>' +
        '</div>';
      $('[data-mp-goto]', body).addEventListener('click', function(){ cart.close(); });
      return;
    }

    foot.hidden = false;
    body.innerHTML =
      '<div class="mp-line-item">' +
        '<img src="' + CFG.cartImg + '" alt="" width="100" height="115">' +
        '<div>' +
          '<h3>Dog Back Seat Extender</h3>' +
          '<p class="mp-line-meta">Black · <s>' + money(WAS) + '</s> ' + money(PRICE) + ' each</p>' +
          '<div class="mp-line-actions">' +
            '<div class="mp-qty" role="group" aria-label="Quantity in cart">' +
              '<button type="button" data-mp-cstep="-1" aria-label="Remove one"' + (inCart <= 1 ? ' disabled' : '') + '><svg class="mp-icon"><use href="#i-minus"/></svg></button>' +
              '<input type="number" value="' + inCart + '" min="1" max="' + MAX + '" aria-label="Quantity" data-mp-cqty>' +
              '<button type="button" data-mp-cstep="1" aria-label="Add one"' + (inCart >= MAX ? ' disabled' : '') + '><svg class="mp-icon"><use href="#i-plus"/></svg></button>' +
            '</div>' +
            '<button class="mp-remove" type="button" data-mp-remove>Remove</button>' +
          '</div>' +
        '</div>' +
      '</div>' +
      '<div class="mp-line-item mp-gift-line">' +
        '<img src="' + CFG.gloveImg + '" alt="" width="100" height="115">' +
        '<div>' +
          '<h3>Pet hair remover glove</h3>' +
          '<p class="mp-line-meta">Free for 30 days</p>' +
          '<p class="mp-gift-price">Qty ' + inCart + ' · FREE</p>' +
        '</div>' +
      '</div>';
    $('#mp-subtotal').textContent = money(PRICE * inCart);
    $('#mp-savings').textContent = '-' + money((WAS - PRICE) * inCart);

    $$('[data-mp-cstep]', body).forEach(function(b){
      b.addEventListener('click', function(){
        cambiar(inCart + (+b.getAttribute('data-mp-cstep'))).then(function(){
          say('Quantity updated: ' + inCart);
          var nb = $('[data-mp-cstep="' + b.getAttribute('data-mp-cstep') + '"]', body);
          if (nb && !nb.disabled) nb.focus(); else { var q = $('[data-mp-cqty]', body); if (q) q.focus(); }
        });
      });
    });
    $('[data-mp-cqty]', body).addEventListener('change', function(e){
      var v = parseInt(e.target.value, 10);
      cambiar(isNaN(v) ? inCart : v).then(function(){ say('Quantity updated: ' + inCart); });
    });
    $('[data-mp-remove]', body).addEventListener('click', function(){
      cambiar(0).then(function(){
        say('Removed from your cart');
        var ir = $('[data-mp-goto]', body); if (ir) ir.focus();
      });
    });
  };

  $('#mp-open-cart').addEventListener('click', function(e){ open(cart, e.currentTarget); leerCarrito(); });
  $('#mp-checkout').addEventListener('click', function(){ window.location.href = '/checkout'; });

  // agregar: bloquea el doble clic y solo confirma cuando Shopify responde
  var busy = false;
  $$('[data-mp-add]', root).forEach(function(btn){
    btn.addEventListener('click', function(){
      if (busy) return;
      busy = true;
      var buttons = $$('[data-mp-add]', root);
      buttons.forEach(function(b){ b.disabled = true; $('[data-mp-add-label]', b).textContent = 'Adding…'; });
      var n = readQty();
      var items = [{ id: VARIANT, quantity: n }];
      if (GLOVE) items.push({ id: GLOVE, quantity: n });
      postJSON('/cart/add.js', { items: items })
        .then(leerCarrito)
        .then(function(){
          say(n + (n === 1 ? ' extender' : ' extenders') + ' added to your cart');
          open(cart, btn);
        })
        .catch(function(){ say('We could not add it right now. Please try again.'); })
        .then(function(){
          buttons.forEach(function(b){ b.disabled = false; $('[data-mp-add-label]', b).textContent = 'Add to cart'; });
          busy = false;
        });
    });
  });

  paintQty();
  paintCart();
  leerCarrito();
})();
